module.exports = __webpack_public_path__ + "img/FAQ.f1a7683a.png";